// extracted by mini-css-extract-plugin
module.exports = {"samples":"style_samples__1QlCb","examples":"style_examples__1eUhh","example":"style_example__3yACB"};